import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/data/content";

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
                scrolled
                    ? "bg-cream border-b-4 border-navy"
                    : "bg-cream/80 backdrop-blur-sm"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-3 flex items-center justify-between">
                <a
                    href="#inicio"
                    data-testid="navbar-logo"
                    className="flex items-center gap-3"
                >
                    <img
                        src={LOGO_URL}
                        alt="Luna Markab Publicitaria"
                        className="h-12 md:h-14 w-auto"
                    />
                </a>

                <nav className="hidden lg:flex items-center gap-1">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="px-4 py-2 font-display uppercase tracking-wider text-navy text-sm hover:bg-navy hover:text-cream transition-colors border-2 border-transparent hover:border-navy"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#contacto"
                        data-testid="nav-cta-button"
                        className="ml-3 retro-btn !py-2 !px-5 !text-sm"
                    >
                        Cotizar ahora
                    </a>
                </nav>

                <button
                    aria-label="Menú"
                    data-testid="navbar-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="lg:hidden border-4 border-navy bg-gold text-navy p-2 hard-shadow-sm"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="navbar-mobile-menu"
                    className="lg:hidden bg-cream border-t-4 border-navy"
                >
                    <div className="flex flex-col px-5 py-4 gap-2">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-link-mobile-${l.label.toLowerCase()}`}
                                className="px-3 py-3 font-display uppercase tracking-wider text-navy border-b-2 border-navy/20"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#contacto"
                            onClick={() => setOpen(false)}
                            data-testid="nav-cta-button-mobile"
                            className="retro-btn mt-3 self-start"
                        >
                            Cotizar ahora
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
